import React from 'react';
import { Card, Button, Alert, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import UserInfoSection from './UserInfoSection';
import StaffInfoSection from './StaffInfoSection';

const StaffInformationCombined = ({
                                      formData,
                                      currentUser,
                                      onSave,
                                      onFieldChange,
                                      isSaving,
                                      validationErrors = {},
                                      attemptedSave = false
                                  }) => {
    const { t } = useTranslation('staffInformation');

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Notify parent component of the field change
        if (onFieldChange) {
            onFieldChange(name, value);
        }
    };

    const handleSave = async () => {
        try {
            // Call the parent's save handler with the current form data
            await onSave(formData);
        } catch (error) {
            console.error('Error in handleSave:', error);
            // Error handling is managed by the parent component
        }
    };

    return (
        <Card className="shadow-lg rounded mt-4">
            <Card.Body>
                <UserInfoSection currentUser={currentUser} />
                <hr className="my-4" />

                <StaffInfoSection
                    staffData={formData}
                    handleChange={handleChange}
                    errors={validationErrors}
                    showValidation={attemptedSave}
                />

                {/* Field-specific validation errors */}
                {attemptedSave && Object.keys(validationErrors).length > 0 && (
                    <div className="mt-3 mb-3">
                        {Object.entries(validationErrors).map(([field, message]) => (
                            <Alert key={field} variant="danger" className="p-2 mb-2">
                                <strong>{field.replace(/_/g, ' ')}:</strong> {message}
                            </Alert>
                        ))}
                    </div>
                )}

                <div className="d-flex justify-content-end mt-4">
                    <Button
                        variant="success"
                        className="shadow-sm"
                        onClick={handleSave}
                        disabled={isSaving} // Only disable during saving
                    >
                        {isSaving ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                {t('staffInformationForm.buttons.saving')}
                            </>
                        ) : (
                            t('staffInformationForm.buttons.save')
                        )}
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default StaffInformationCombined;